import systemSettingApi from '@/api/system-setting'
import { generateFormHandlerMutations } from '@/helpers/forms'

const emptyProgram = () => ({
  name: '',
  bonusAccountTypeId: 0,
  spentAccountTypeId: 0,
  levelAccountTypeId: 0,
})

const state = {
  programs: [],
  saving: false,
  errors: {
    errors: [],
    commonErrors: [],
  },
}

const getters = {}

const actions = {
  fetch({ commit }) {
    return systemSettingApi.getLoyaltyProgramSettings()
      .then(({ data }) => commit('SET_PROGRAMS', data.programs || []))
      .catch(() => commit('SET_PROGRAMS', []))
  },

  update({ commit }) {
    commit('SAVING')

    return systemSettingApi.updateLoyaltyProgramSettings({ programs: state.programs })
      .then(() => commit('SAVED'))
      .catch(error => {
        commit('SAVE_FAILED', error.response && error.response.data)
        throw error
      })
  },

  addProgram({ commit }) {
    commit('ADD_PROGRAM')
  },

  removeProgram({ commit }, index) {
    commit('REMOVE_PROGRAM', index)
  },
}

const mutations = {
  SET_PROGRAMS(state, programs) {
    state.programs = programs.map(x => ({ ...emptyProgram(), ...x }))
    state.saving = false
  },

  ADD_PROGRAM(state) {
    state.programs = [...state.programs, emptyProgram()]
  },

  REMOVE_PROGRAM(state, index) {
    state.programs = state.programs.filter((x, i) => i !== index)
  },

  SAVING(state) {
    state.saving = true
  },

  SAVED(state) {
    state.saving = false
  },

  SAVE_FAILED(state, data) {
    state.saving = false
    state.errors = data || state.errors
  },

  ...generateFormHandlerMutations(state),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {},
}
